import api from "../../utils/api";

export const getReadMoreProgrammeByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetReadMoreProgrammeByReadmoreId?Id=${id}`))
    ?.data as ReadMoreProgrammeResponse;
};

export const getReadMoreCourseOverviewByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetCourseOverviewByReadmoreId?Id=${id}`))
    ?.data as ReadMoreProgrammeResponse;
};

export const getReadMoreCareerProspectByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetCareerProspectByReadmoreId?Id=${id}`))
    ?.data as CareerProspectResponse;
};

export const getReadMoreCareerProspectItemByCareerProspectId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetCareerProspectItemByCareerProspectId?Id=${id}`))
    ?.data as CareerProspectItemResponse;
};

export const getAllScholarshipByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAllScholarshipByReadmoreId?Id=${id}`))
    ?.data as ScholarshipResponse;
};

export const getAllTestimonialByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetTestimonialByReadmoreId?Id=${id}`))
    ?.data as TestimonialResponse;
};

export const getAccreditationByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAccreditationByReadmoreId?Id=${id}`))
    ?.data as AccreditationResponse;
};

export const getTuitionByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetTuitionByReadMoreId?Id=${id}`))
    ?.data as TuitionResponse;
};

export const getApplicationFeesByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetFeeSetupByProgramId?Id=${id}`))
    ?.data as TuitionResponse;
};

export const getAllCurriculumByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAllcurriculumByReadmoreId?Id=${id}`))
    ?.data as CurriculumResponse;
};

export const getAdmissionReqByReadMoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAdmissionRequirementByReadmoreId?Id=${id}`))
    ?.data as AdmissionReqResponse;
};

export const getAdmissionReqDetailsByAdmissionReqId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAdmissionRequirementDetailByAdmissionReqId?Id=${id}`))
    ?.data as AdmissionReqDetailsResponse;
};

export const getAllTuitionYearByLevelIdReadmoreId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAllTuitionYearbyLevelIdReadmoreId?Id=${id}`))
    ?.data as TuitionYearResponse;
};

export const getAllTuitionYearByTuitionId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetAllTuitionYearbyTuitionId?Id=${id}`))
    ?.data as TuitionYearResponse;
};

export const getAllApplicationFeeByProgramId = async (id: string | number) => {
  return (await api.get(`/ReadMore/GetFeeSetupByProgramId?Id=${id}`))
    ?.data as ApplicationFeeResponse;
};